import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { AWS_URL } from "../../Constant";


export default function PunchIn() {
  const [location, setLocation] = useState(null);
  const [selfie, setSelfie] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  // Get GPS location
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocation({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
      },
      (err) => {}
    );
  }, []);

  // Capture selfie
  const handleSelfie = (e) => {
    if (e.target.files[0]) {
      setSelfie(e.target.files[0]);
    }
  };

  const handlePunch = async (type) => {
    if (!location || !selfie) {
      alert("Please allow location and upload selfie!");
      return;
    }
    setLoading(true);

    // Normally upload file → backend API
    const formData = new FormData();
    formData.append("employee_code", "EMP001");
    formData.append("branch_code", "BR001");
    formData.append("location", JSON.stringify(location));
    formData.append("image", selfie);
    formData.append("lat", location.lat);
    formData.append("lng", location.lng);

   ;try {
      const jwtToken = Cookies.get("jwt_token");
      const res = await fetch(
        `${AWS_URL}/attendance/${type}`, 
        {
          method: "POST",
          headers: {
            //  "Content-Type": "application/json",
            Authorization:`Bearer ${jwtToken}`,
          },
          body: formData,
        }
      );
      
      const data = await res.json();setStatus(data.msg || "Success");
    } catch (err) {setStatus("Error!");
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <div className="bg-white shadow-xl rounded-2xl p-6 w-full max-w-md text-center">
        <h2 className="text-xl font-bold mb-4">Employee Attendance</h2>

        <input
          type="file"
          accept="image/*"
          capture="user"
          onChange={handleSelfie}
          className="mb-4"
        />

        <div className="flex gap-4 justify-center">
          <button
            onClick={() => handlePunch("punch-in")}
            disabled={loading}
            className="px-4 py-2 bg-green-500 text-white rounded-lg shadow hover:bg-green-600"
          >
            Punch In
          </button>
          <button
            onClick={() => handlePunch("punch-out")}
            disabled={loading}
            className="px-4 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600"
          >
            Punch Out
          </button>
        </div>

        {status && (
          <p className="mt-4 text-gray-700 font-medium">{status}</p>
        )}
      </div>
    </div>
  );
}
